export enum PaymentStatusEnum {
  Pending = 1,
  Authorised = 2,
  Paid = 3,
  Expired = -1,
  Cancelled = -2,
  Declined = -3,
}
